module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS14.36e8cc31.jpg";